import { useEffect, useState } from 'react'
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useApiProgress } from '../../hooks/ApiProgress';
import { ENTITY_IS_IN_USE_MESSAGE, EXCEL_VALIDATION_MESSAGE } from '../../utils/constants';
import readXlsxFile, { readSheetNames } from 'read-excel-file';
import { toast } from 'react-toastify';
import Input from '../../components/Input';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import Button from '../../components/Button';
import { GoPlus } from 'react-icons/go';
import DeleteModal from '../../components/DeleteModal';
import { translateStatus } from '../../utils/translator';
import { pageModel } from '../../utils/model';
import { PRODUCTION_RECORD_PATH, chargeProductionRecord, deChargeProductionRecord, deleteProductionRecord, downloadProductionRecordReceipt, getPageProductionRecords, uploadProductionRecordExcelFile } from '../../api/productionRecordApi';
import { formatDate, formatNumber } from '../../utils/functions';
import { FaReceipt } from 'react-icons/fa';
import { OUTSOURCER_PATH, getPageOutsourcers } from '../../api/outsourcerApi';
import OutsourcerPicker from '../../components/outsourcer/OutsourcerPicker';
import { setproductionRecordSearchParamsAction } from '../../redux/feature/searchParamsSlice';
import Spinner from '../../components/Spinner';
import { RxCross1 } from 'react-icons/rx';
import { FaCheck } from "react-icons/fa";
import ProductPicker from '../../components/product/ProductPicker';
import { getPageProducts, PRODUCT_PATH } from '../../api/productApi';
import ChargeModal from '../../components/ChargeModal';

const ProductionRecordListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [productionRecordPage, setProductionRecordPage] = useState(pageModel)
    const pendingApiCall = useApiProgress('get', `${PRODUCTION_RECORD_PATH}/page`, false)
    const pendingApiCallDelete = useApiProgress('delete', `${PRODUCTION_RECORD_PATH}`, false)
    const searchParams = useSelector(state => state.searchParams.productionRecord)
    const [outsourcerPage, setOutsourcerPage] = useState({
        content: []
    });
    const [outsourcerQuery, setOutsourcerQuery] = useState('')
    const [searchTimerOutsourcer, setSearchTimerOutsourcer] = useState();
    const pendingApiCallOutsourcer = useApiProgress('get', `${OUTSOURCER_PATH}/page`, false)
    const pendingApiCallProduct = useApiProgress('get', `${PRODUCT_PATH}/page`, false)
    const [productQuery, setProductQuery] = useState('')
    const [searchTimerProduct, setSearchTimerProduct] = useState();
    const [isOpenChargeModal, setIsOpenChargeModal] = useState(false)
    const [selected, setSelected] = useState()

    const [productPage, setProductPage] = useState({
        content: []
    });

    const onClickLoadMoreProduct = () => {
        if (!productPage.last) {
            loadProducts({ search: productQuery, lastId: productPage.content[productPage.content.length - 1]?.id })
        }
    }
    const loadProducts = (params) => {
        !pendingApiCallProduct &&
            getPageProducts(params)
                .then(res => {
                    setProductPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const searchingOutsourcer = async (params) => {
        if (searchTimerOutsourcer) clearTimeout(searchTimerOutsourcer);
        let timer = setTimeout(() => {
            getPageOutsourcers(params)
                .then(res => {
                    setOutsourcerPage(res.data)
                })
        }, 500);
        setSearchTimerOutsourcer(timer);
    }

    const onClickLoadMoreOutsourcer = () => {
        if (!outsourcerPage.last) {
            loadOutsourcers({ search: outsourcerQuery, lastId: outsourcerPage.content[outsourcerPage.content.length - 1]?.id })
        }
    }

    const loadOutsourcers = (params) => {
        !pendingApiCallOutsourcer &&
            getPageOutsourcers(params)
                .then(res => {
                    setOutsourcerPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)
    const [searchTimer, setSearchTimer] = useState();

    const searchingProduct = async (params) => {
        if (searchTimerProduct) clearTimeout(searchTimerProduct);
        let timer = setTimeout(() => {
            getPageProducts(params)
                .then(res => {
                    setProductPage(res.data)
                })
        }, 500);
        setSearchTimerProduct(timer);
    }

    useEffect(() => {
        loadProductionRecords({ size: 20, ...searchParams, outsourcerId: searchParams.outsourcer?.id, productId: searchParams.product?.id })
        loadOutsourcers({ size: 20 })
        loadProducts({ size: 20 })
    }, [])

    const onLoadMore = () => {
        if (!productionRecordPage.last) {
            loadProductionRecords({ ...searchParams, outsourcerId: searchParams.outsourcer?.id, productId: searchParams.product?.id, lastId: productionRecordPage.content[productionRecordPage.content.length - 1]?.id })
        }
    }

    useEffect(() => {
        !isFirstRender && searchingOutsourcer({ search: outsourcerQuery })
    }, [outsourcerQuery])

    useEffect(() => {
        !isFirstRender && searchingProduct({ search: productQuery })
    }, [productQuery])

    useEffect(() => {
        !isFirstRender && searching({ ...searchParams, outsourcerId: searchParams.outsourcer?.id, productId: searchParams.product?.id })
    }, [searchParams])

    const loadProductionRecords = (params) => {
        !pendingApiCall &&
            getPageProductionRecords(params)
                .then(res => {
                    setProductionRecordPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageProductionRecords(params)
                .then(res => {
                    setProductionRecordPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const onClickDelete = () => {
        deleteProductionRecord(deleteId)
            .then(res => {
                setIsOpen(false)
                setProductionRecordPage(prevState => ({ ...prevState, content: prevState.content.filter(c => c.id !== res.data) }))
                toast.success('Silindi')
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }

    const onClickCharge = (p) => {
        if (p.charged) {
            deChargeProductionRecord(p.id)
                .then(res => {
                    setProductionRecordPage(prevState => ({
                        ...prevState,
                        content: prevState.content.map(x => {
                            if (x.id === p.id) return res.data
                            else return x
                        })
                    }))
                })
        } else {
            chargeProductionRecord(p.id)
                .then(res => {
                    setProductionRecordPage(prevState => ({
                        ...prevState,
                        content: prevState.content.map(x => {
                            if (x.id === p.id) return res.data
                            else return x
                        })
                    }))
                })
        }
        setIsOpenChargeModal(false)

    }

    const onClickReceipt = (productionRecord) => {
        downloadProductionRecordReceipt(productionRecord.id)
            .then(res => {
                const blob = new Blob([res.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = productionRecord.outsourcerName + ` üretim-fişi #${productionRecord.id}.pdf`;
                a.click();
                window.URL.revokeObjectURL(url);
            }).catch(err => {
                toast.error('Dosya indirilirken hata oluştu!')
            })
    }

    const uploadExcelFile = async (event) => {
        const file = event.target.files[0];
        if (!Boolean(file)) return;
        const sheets = await readSheetNames(file);
        let rows;
        for (const sheet of sheets) {
            rows = await readXlsxFile(file, { sheet });
            rows.shift();
        }
        const items = []
        for (const row of rows) {
            items.push({
                outsourcerCode: row[0],
                date: row[1],
                invoiceNumberIn: row[2],
                invoiceNumberIn: row[3],
                vat: row[4],
                cost: row[5]
            })
        }
        uploadProductionRecordExcelFile(items)
            .then(res => {
                toast.success("Kayıtlar güncellendi")
            }).catch(err => {
                toast.error(EXCEL_VALIDATION_MESSAGE)
            })
    }

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl'>
                    ÜRETİM KAYITLARI
                </label>
            </div>
            <div className='flex gap-x-2 py-2 sticky top-0 bg-zinc-50'>
                <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Üretim</label>}
                    variant='green'
                    onClick={() => nav('/production-record/add')}
                />
            </div>
            <div className='shadow-lg border rounded-md p-2 mb-5'>
                <label className='block'>Filtreler</label>
                <div className='grid grid-cols-4 gap-x-3 '>
                    <div className='col-span-1'>
                        <ProductPicker
                            className='mb-0'
                            label={`Ürün`}
                            label2='Seçili ürünü içeren siparişler filtrelenir'
                            pendingApiCall={pendingApiCallProduct}
                            state={searchParams.product}
                            setState={(value) => dispatch(setproductionRecordSearchParamsAction({ key: 'product', value }))}
                            query={productQuery}
                            setQuery={setProductQuery}
                            // error={errors.productId}
                            page={productPage}
                            // setErrors={() => setErrors(prevState => ({ ...prevState, productId: undefined }))}
                            onClickClear={() => dispatch(setproductionRecordSearchParamsAction({ key: 'product', value: null }))}
                            onClickLoadMore={() => onClickLoadMoreProduct()}
                        />
                    </div>
                    <div className='col-span-1'>
                        <Input
                            name='boilerCode'
                            label='Kazan no'
                            label2="Kazan no'yu içeren siparişler filtrelenir"
                            placeholder='Kazan no girin...'
                            value={searchParams.boilerCode}
                            onChange={e => dispatch(setproductionRecordSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                        />

                    </div>

                </div>

            </div>
            <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/24'>Id</th>
                        <th className='p-2 w-2/12'>
                            <div className='flex justify-between' >
                                <div className='flex gap-x-2'>
                                    <span>
                                        Fasoncu Adı
                                    </span>
                                    <span>
                                        {pendingApiCallOutsourcer && <Spinner />}
                                    </span>
                                </div>
                                {
                                    searchParams.outsourcer &&
                                    <span className='cursor-pointer' onClick={() => dispatch(setproductionRecordSearchParamsAction({ key: 'outsourcer', value: null }))} >
                                        <RxCross1 />
                                    </span>
                                }
                            </div>
                        </th>
                        <th className='p-2 w-1/12'>Tarih</th>
                        <th className='p-2 w-1/12'>Ftr. çıkış</th>
                        <th className='p-2 w-1/12'>Ftr. giriş</th>
                        <th className='p-2 w-2/12'>İşlemler</th>
                        <th className='p-2 w-1/12'>Kullanıcı</th>
                        <th className='p-2 w-1/12'>Tutar</th>
                        <th className='p-2 w-1/12'>Durum</th>
                        <th className='p-2 w-1/24'>Hesapta</th>
                        <th className='p-2 w-1/24'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-20 bg-zinc-50'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                value={searchParams.id}
                                onChange={e => dispatch(setproductionRecordSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            <OutsourcerPicker
                                state={searchParams.outsourcer}
                                setState={(value) => dispatch(setproductionRecordSearchParamsAction({ key: 'outsourcer', value }))}
                                query={outsourcerQuery}
                                setQuery={setOutsourcerQuery}
                                page={outsourcerPage}
                                // onClickClear={() => setOutsourcer()}
                                onClickLoadMore={() => onClickLoadMoreOutsourcer()}
                            />
                        </td>
                        <td></td>
                        <td>
                            <Input
                                name="invoiceNumberOut"
                                placeholder='Fatura No...'
                                value={searchParams.invoiceNumberOut}
                                onChange={e => dispatch(setproductionRecordSearchParamsAction({ key: "invoiceNumberOut", value: e.target.value }))}
                            /></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                            <select
                                onChange={e => {
                                    let value = e.target.value
                                    dispatch(setproductionRecordSearchParamsAction({ key: 'status', value }))
                                }}
                            >
                                <option value={""}> Tümü</option>
                                <option value={0}> Beklemede</option>
                                <option value={1}> İşlemde</option>
                                <option value={2}> Tamamlandı</option>
                            </select>
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                    {
                        productionRecordPage.content.map((productionRecord, index) => (
                            <tr key={index} className='border-b items-center hover:bg-violet-100 duration-150'>
                                <td className='p-2'># {productionRecord.id} </td>
                                <td className='p-2'>{productionRecord.outsourcerName} </td>
                                <td className='p-2'>{formatDate(productionRecord.productionDate)}</td>
                                <td className='p-2'>{productionRecord.invoiceNumberOut}</td>
                                <td className='p-2'>{productionRecord.invoiceNumberIn} </td>
                                <td className='p-2'>{productionRecord.operationNames}</td>
                                <td className='p-2'>{productionRecord.user}</td>
                                <td className='p-2'>{productionRecord.charged ? `${formatNumber(productionRecord.cost)} ${productionRecord.currency}` : "-"} </td>
                                <td className={`text-center text-white text-xs`}>
                                    <label className={`${productionRecord.status === 'COMPLETED' ? 'bg-green-700 ' : productionRecord.status === 'IN_PROGRESS' ? 'bg-blue-700' : 'bg-yellow-500'} p-2 rounded-md`}>
                                        {translateStatus(productionRecord.status)}
                                    </label>
                                </td>
                                <td className='p-2 w-1/12'>
                                    <input
                                        type='checkbox'
                                        checked={productionRecord.charged}
                                        // defaultChecked={productionRecord.charged}
                                        onChange={() => {
                                            setSelected(productionRecord)
                                            setIsOpenChargeModal(true)
                                        }}
                                    />
                                </td>
                                <td className='p-2 items-center'>
                                    {
                                        !productionRecord.formerRecord &&
                                        <>
                                            {
                                                <div className='flex gap-x-3'>
                                                    <span className='cursor-pointer hover:scale-125 hover:text-zinc-600 duration-150'>
                                                        <FaReceipt onClick={() => onClickReceipt(productionRecord)} />
                                                    </span>
                                                    <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/production-record/edit/${productionRecord.id}`)}>
                                                        <AiFillEdit />
                                                    </span>
                                                    {

                                                        !productionRecord.charged &&
                                                        <>

                                                            <span
                                                                className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                                                onClick={() => {
                                                                    setIsOpen(true)
                                                                    setDeleteId(productionRecord.id)
                                                                }}
                                                            >
                                                                <AiFillDelete />
                                                            </span>
                                                        </>
                                                    }
                                                </div>
                                            }
                                        </>
                                    }
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={productionRecordPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
            <DeleteModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                onClick={onClickDelete}
                pendingApiCall={pendingApiCallDelete}
            />
            <ChargeModal
                isOpen={isOpenChargeModal}
                closeModal={() => setIsOpenChargeModal(false)}
                onSubmit={() => onClickCharge(selected)}
            />
        </div>
    )
}

export default ProductionRecordListPage